var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Sentry from '@sentry/react';
import { conversations } from '../../services/api/scribe';
export const fetchTrainingFiles = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const res = yield conversations.getTrainingConversations();
        dispatch({
            type: 'FETCH_SCRIBE_TRAINING_SUCCESS',
            trainings: res.data,
        });
    }
    catch (e) {
        console.log('Failed to load training conversations');
        Sentry.captureException(e);
    }
});
export const scribeSetFontSize = (fontSize) => ({
    type: 'SCRIBE_SET_FONT_SIZE',
    fontSize,
});
export const setScribeCorrectionMode = (correctionMode) => ({
    type: 'SCRIBE_SET_CORRECTION_MODE',
    correctionMode,
});
